export default __webpack_public_path__ + "static/media/sampleaudio.82fc5a50.ogg";